<template>
    <div>
        <div class="zebra-crossing-detail">
            <el-form ref="ruleForm" :model="ruleForm" :rules='rules'  v-loading='loading' label-width="120px">

                <!-- 分类、所属公司 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="分类" prop="category">
                            <el-cascader style='width: 200px' ref='category' :props="category" clearable v-model="ruleForm.category" :show-all-levels="false" props.checkStrictly=true
                                         @change="showSelect"
                            >
                                <template slot-scope="{ node, data }">
                                    <span>{{ data.label }}</span>
                                </template>
                            </el-cascader>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="所属公司" prop='company'>
                            <el-select style='width: 200px;' v-model="ruleForm.company" placeholder="请选择" clearable @change="companyEvent">
                                <el-option v-for="item in company" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 配置名称、所属部门 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="配置名称" prop='title'>
                            <el-input style='width: 200px;' v-model="ruleForm.title"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="所属部门" prop='department'>
                            <el-cascader style='width: 200px' ref='department' :props="department" clearable v-model="ruleForm.department" :show-all-levels="false" @change="departmentSelect">
                                <template slot-scope="{ node, data }">
                                    <span>{{ data.label }}</span>
                                </template>
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 配置项编号、拥有者 -->
                <!-- -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="拥有者" class='having' prop='owner'>
                            <div class="el-form__inline">
                                <el-input type="text" placeholder="请选择拥有者" disabled v-model="ruleForm.owner" style='width: 200px;marginRight: 5px;'></el-input>
                                <router-link :to="{ path:'/requeryUserList',query: { callback:getReporter, variable:'owner'} }">
                                    <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                                </router-link>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="状态">
                            <el-select style='width: 200px;' v-model="ruleForm.status" placeholder="请选择状态">
                                <el-option v-for="item in cmdbStatus" :key="item.id" :label="item.cname" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 状态、使用者 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="使用者" class='having'>
                            <div class="el-form__inline">
                                <el-input type="text" placeholder="请选择使用者" disabled v-model="ruleForm.user" style='width: 200px;marginRight: 5px;'></el-input>
                                <router-link :to="{ path:'/requeryUserList',query: { callback:getReporter, variable:'user'} }">
                                    <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                                </router-link>
                            </div>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="配置项编号" v-if="this.type!='add'">
                            <el-input style='width: 200px;' v-model="ruleForm.serialNumber" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!--&lt;!&ndash; 上传附件 &ndash;&gt;-->
                <!--<el-row>-->
                    <!--<el-col :span='24'>-->
                        <!--<el-form-item label="上传附件:">-->
                            <!--<a href="javascript:void(0);" class="input">-->
                                <!--上传文件-->
                                <!--<input type="file" id="file" name="document[file]" @change="changeFn">-->
                            <!--</a>-->
                            <!--<div v-if="ruleForm.attachment.length>0">-->
                                <!--<div v-for="(item, index) in ruleForm.attachment" :key="index">{{item.name}}</div>-->
                            <!--</div>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                <!--</el-row>-->
                <!--附件-->
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="附件">
                            <inputFile :data="ruleForm.attachment" :getFiles="getFiles"></inputFile>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-tabs v-model="activeName" @tab-click="handleClick" class="configTab">
                    <el-tab-pane :label="item.name" :name="item.index" v-for="item in tabViews" :key="item.index" >
                        <div v-loading="loading" v-if="loading" style="width:100%;height:300px;"></div>
                        <keep-alive v-if="!loading">
                            <component :is="currentView"
                                       :ruleForm="ruleForm"
                                       :configPros="configPros"
                                       :cmdbAssetType="cmdbAssetType"
                                       :innerPops="innerPop"
                                       :envType="envType"
                                       :brand="brand"
                                       :supplier="supplier"
                                       :location="location"
                                       :handleCloses="handleClose"
                                       :compare1="compare1"
                                       :compare2="compare2"
                                       :showConfigPros="showConfigPros"
                            ></component>
                        </keep-alive>
                    </el-tab-pane>
                </el-tabs>

                <!-- 确定、重置 -->
                <el-row>
                    <el-col :span='24'>
                        <el-form-item>
                            <el-button type='primary' @click='submitForm("ruleForm")' :disabled="isSubmit">确定</el-button>
                            <el-button type='primary' @click='() => $refs["ruleForm"].resetFields()'>重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <!-- 内弹框 -->
        <el-dialog :title="innerTitle" :visible.sync="innerVisible" append-to-body>
            <!--<div slot="header" class="dialog-header">-->
                <!--<el-form-item>-->
                    <!--<el-input v-model="form.keyword" placeholder="请输入关键字"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item>-->
                    <!--<el-button type="primary" @click="request">搜索</el-button>-->
                <!--</el-form-item>-->
            <!--</div>-->
            <add-service v-if='innerTitle === "影响服务"' @getServes='nodes => this.getChildData = nodes'/>

            <add-user v-if='innerTitle === "厂商联系人"' @getServes='nodes => this.getChildData = nodes'/>

            <add-document v-if='innerTitle === "文件"' @getServes='nodes => this.getChildData = nodes' :filterCondition="1"/>

            <div slot="footer" class="dialog-footer">
                <el-button @click="innerVisible = false">取 消</el-button>
                <el-button type="primary" @click="getData" >确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getRules } from './configuration.rules'
import inputFile from "../common/inputFile.vue"
import sendServices from './configuration.services'
import commonService from "../../services/common.service"

import AddService from '../../components/AddService/index'
import AddUser from '../../components/AddUser/index'
import addDocument from '../../components/addDocument/index'
import basicPro from  './basicPro'
import configPro from './configPro'

const rules = getRules()

export default {

    components: { AddService, AddUser, addDocument ,basicPro,configPro,inputFile},

    props:{
        type:{
            type:String,
            default:"add"
        },
        serialNumber: String,
        callback: Function,
    },

    created() {
        if (this.type === "edit") {
            this.$modal.title = "修改配置项"
            this.query()
            // console.log(this.ruleForm.category,'category');
        }
        this.loading = false
        // console.log(this.cmdbAssetType);
    },

    computed: {
        currentView(){
            return this.tabViews[this.index].index;
        },
        // 字典
        dictionary() {
            return this.$store.state.dictionary
        },

        // 配置项状态
        cmdbStatus() {
            return this.dictionary.cmdb_status
        },

        // 资产类型
        cmdbAssetType() {
            return this.dictionary.cmdb_asset_type
        },

        // 环境类型
        envType() {
            return this.dictionary.env_type
        },

        // 品牌
        brand() {
            return this.dictionary.brand
        },

        // 供应商
        supplier() {
            return this.dictionary.supplier
        },

        // 所在位置
        location() {
            return this.dictionary.location
        }
    },

    data() {
        return {
            ruleForm: {
                owner: '',
                user: '',
                status: "97",
                toDocument: [],
                toUser: [],
                attachment: [],
                toService: [],
                company: "",
                department: "",
                toChange:[],
                toDeploy:[],
                toEvent:[],
                toCmdb:[],
                toProblem:[],
            },
            attachment:[],    // 存放上传的附件
            tabViews:[
                { name:"基础属性",index:"basicPro"},
                { name:"配置属性",index:"configPro"},
            ],
            activeName:'basicPro',
            index:0,
            configPros:{
                structure:''
            },
            innerVisible: false,
            innerTitle: "",
            getChildData: [],
            loading: true,
            showConfigPros:null,
            rules,
            owner: '',
            iser: '',
            category: {
                lazy: true,
                checkStrictly: true,
                lazyLoad: (node, resolve) => this.categoryLazyLoad(node, resolve)
            },
            company: [],
            isSubmit:false,
            department: {
                lazy: true,
                checkStrictly: true,
                lazyLoad: (node, resolve) => this.departmentLazyLoad(node, resolve)
            },

        };
    },

    mounted() {
        sendServices.companyList()
            .then(res => this.company = res.list)
            .catch(err => this.$message.error(err.message))
    },

    methods: {

        showSelect(){
            this.showConfigPros=false
            // console.log(this.ruleForm.category,'this.ruleForm.category');
            let getCategory=this.ruleForm.category[this.ruleForm.category.length-1]
            if (getCategory&&getCategory.title.indexOf('服务器')>-1){
                        // console.log('hahaha');
                        this.showConfigPros=true
            }
        },
        //开始时间和完成时间的对比校验
        CompareDate(d1,d2) {
            //将所有的短横线替换为斜杠
            return ((new Date(d1.replace(/-/g,"\/"))) > (new Date(d2.replace(/-/g,"\/"))));
        },
        //采购时间和到货时间的对比校验
        compare1(){
            let start=this.ruleForm.purchaseTime
            let end = this.ruleForm.arrivalTime
            if (this.ruleForm.purchaseTime&&this.ruleForm.arrivalTime) {
                if (this.CompareDate(start,end)){
                    this.$message.error('到货时间应比采购时间晚，请重新选择')
                    this.ruleForm.arrivalTime=''
                }
            }

        },
        //保修开始时间和保修结束时间的对比校验
        compare2(){
            let start=this.ruleForm.warrantyStartTime
            let end=this.ruleForm.warrantyEndTime
            if (this.ruleForm.warrantyStartTime&&this.ruleForm.warrantyEndTime) {
                if(this.CompareDate(start,end)){
                    this.$message.error('保修结束时间应比保修开始时间晚，请重新选择')
                    this.ruleForm.warrantyEndTime=''
                }
            }
        },
        //上传附件
        getFiles(val){
            this.attachment = val;
            console.log(this.attachment)
        },
        // 通过组件获取参数
        getReporter(item, user) {
            this[user] = item.userid
            this.ruleForm[user] = item.name
        },

        // 删除影响服务、厂商联系人、文件某一项
        handleClose(tag, rows) {
            rows.splice(rows.indexOf(tag), 1);
        },

        // 部门懒加载请求
        departmentLazyLoad(node, resolve) {
            console.log(node)
            // console.log(resolve)
            // this.departmentNode = node
          if (node.root) {
                sendServices.treeTop({include_group:0}).then(res => {
                    let newArr = res.list.map(item => {
                        return { leaf: !item.children, value: item.id, label: item.name };
                    });
                    resolve(newArr);
                })
            } else {
                let { value } = node
                sendServices.treeChildren({ departmentId:node.value }).then(res => {
                    let newArr = res.list.map(item => {
                        return { leaf: !item.children, value: item.id, label: item.name };
                    });
                    resolve(newArr);
                })
            }

            // sendServices
            //     .treeChildren({ departmentId: node.value || 1 })
            //     .then(res => {
            //     let newArr = res.list.map(item => {
            //         return { leaf: !item.children, value: item.id, label: item.name };
            //     });
            //     resolve(newArr);
            //     });
        },
        departmentSelect(node, resolve){
            console.log(node)
        },
        // 所属部门事件
        companyEvent(val){
            console.log(val)


        },
        // 分类懒加载请求
        categoryLazyLoad(node, resolve) {
            if (!node.level) {
                sendServices.typeList({ type: 11 }).then(res => {
                let newArr = res.map(item => {
                    return {
                    leaf: !item.hasChildren,
                    value: item,
                    label: item.title
                    };
                });
                resolve(newArr);
                });
            } else {
                sendServices.childrenList({ parentId: node.value.id }).then(res => {
                let newArr = res.map(item => ({
                    leaf: !item.hasChildren,
                    value: item,
                    label: item.title
                    }));
                resolve(newArr);
                });
            }
        },

        // 上传文件(没用的方法)
        changeFn(e) {
            let files = e.target.files || e.dataTransfer.files;
            let params = {
                file_name: files[0]
            };
            commonService
                .uploading(params)
                .then(res => {
                let fileData = {};
                fileData.name = res.file_name;
                fileData.url = res.download_url;
                this.ruleForm.attachment.push(fileData);
                this.$message.success("导入成功");
                })
                .catch(err => {
                this.$message.error(err.message);
                });
        },

        // 确认按钮
        submitForm(formName) {
            this.isSubmit=true
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = this.setParams();
                    // console.log(this.ruleForm.category);
                    // console.log(this.ruleForm.category.indexOf(65));
                    if (this.showConfigPros){
                        // console.log('执行添加configPro');
                        let configPro=this.getConfigPros()
                        params={
                            ...params,
                            configProperties:configPro

                        }
                    }
                    if (this.type === "add") {
                        this.request({ request: sendServices.cmdbAdd, params });
                        return
                    }
                    if (this.type === "edit") {
                        if (params.category === '') {
                            params.category
                                = typeof(this.ruleForm.category) === 'object'
                                ? this.ruleForm.category.id
                                : this.ruleForm.category
                        }
                        if (params.department === '') {
                            params.department
                                = typeof(this.ruleForm.department) === 'object'
                                ? this.ruleForm.department.id
                                : this.ruleForm.department
                        }
                        this.request({ request: sendServices.cmdbEdit, params})
                    }
                } else {
                    this.isSubmit=false
                    this.$message.error('✳为必填项，请全部填写')
                }
            });
        },
        //当配置属性存在时获取配置属性
        getConfigPros(){
            return{
                structure:this.configPros.structure?this.configPros.structure:'',
                mac:this.configPros.mac?this.configPros.mac:'',
                ip:this.configPros.ip?this.configPros.ip:'',
                cpuType:this.configPros.cpuType?this.configPros.cpuType:'',
                cpuModel:this.configPros.cpuModel?this.configPros.cpuModel:'',
                cpuFrequency:this.configPros.cpuFrequency?this.configPros.cpuFrequency:'',
                cpuStandardizedQuantity:this.configPros.cpuStandardizedQuantity?this.configPros.cpuStandardizedQuantity:'',
                cpuMaxQuantity:this.configPros.cpuMaxQuantity?this.configPros.cpuMaxQuantity:'',
                cpuManufacturing:this.configPros.cpuManufacturing?this.configPros.cpuManufacturing:'',
                level3Cache:this.configPros.level3Cache?this.configPros.level3Cache:'',
                cpuBus:this.configPros.cpuBus?this.configPros.cpuBus:'',
                cpuCoreNum:this.configPros.cpuCoreNum?this.configPros.cpuCoreNum:'',
                cpuThreadNum:this.configPros.cpuThreadNum?this.configPros.cpuThreadNum:'',
                motherboardsChip:this.configPros.motherboardsChip?this.configPros.motherboardsChip:'',
                motherboardsExpansionSlot:this.configPros.motherboardsExpansionSlot?this.configPros.motherboardsExpansionSlot:'',
                memoryType:this.configPros.memoryType?this.configPros.memoryType:'',
                memorySize:this.configPros.memorySize?this.configPros.memorySize:'',
                memoryMaxSize:this.configPros.memoryMaxSize?this.configPros.memoryMaxSize:'',
                memoryExpansionSlotNum:this.configPros.memoryExpansionSlotNum?this.configPros.memoryExpansionSlotNum:'',
                diskType:this.configPros.diskType?this.configPros.diskType:'',
                diskSize:this.configPros.diskSize?this.configPros.diskSize:'',
                diskDescribe:this.configPros.diskDescribe?this.configPros.diskDescribe:'',
                diskRack:this.configPros.diskRack?this.configPros.diskRack:'',

                diskHotSwap:this.configPros.diskHotSwap?this.configPros.diskHotSwap:'',
                diskRAID:this.configPros.diskRAID?this.configPros.diskRAID:'',
                diskControl:this.configPros.diskControl?this.configPros.diskControl:'',
                CDDrive:this.configPros.CDDrive?this.configPros.CDDrive:'',
                network:this.configPros.network?this.configPros.network:'',
                powerType:this.configPros.powerType?this.configPros.powerType:'',
                powerNum:this.configPros.powerNum?this.configPros.powerNum:'',
                powerPower:this.configPros.powerPower?this.configPros.powerPower:'',
                appearanceSize:this.configPros.appearanceSize?this.configPros.appearanceSize:'',
                appearanceWeight:this.configPros.appearanceWeight?this.configPros.appearanceWeight:'',
                workingTemperature:this.configPros.workingTemperature?this.configPros.workingTemperature:'',
                workingHumidity:this.configPros.workingHumidity?this.configPros.workingHumidity:'',
                storageTemperature:this.configPros.storageTemperature?this.configPros.storageTemperature:'',
                storageHumidity:this.configPros.storageHumidity?this.configPros.storageHumidity:'',
            }
        },

        // 获取请求所设置的params
        setParams() {
            return {
                id: this.ruleForm.id,
                serialNumber: this.serialNumber && this.serialNumber,
                category: Array.isArray(this.ruleForm.category) ? this.ruleForm.category.pop().id : "",
                company: typeof(this.ruleForm.company) === 'object' ? this.ruleForm.company.id: this.ruleForm.company,
                department: Array.isArray(this.ruleForm.department) ? this.ruleForm.department.pop() : "",
                title: this.ruleForm.title,
                owner: this.owner ? this.owner : this.ruleForm.owner,
                user: this.user ? this.user : this.ruleForm.user,
                status: this.ruleForm.status,
                attachment: this.ruleForm.attachment,
                //attachment: this.attachment,
                assetType: this.ruleForm.assetType,
                purchaseTime: this.ruleForm.purchaseTime,
                assetCost: this.ruleForm.assetCost,
                arrivalTime: this.ruleForm.arrivalTime,
                envType: this.ruleForm.envType,
                borrowEndTime: this.ruleForm.borrowEndTime,
                model: this.ruleForm.model,
                serialNum: this.ruleForm.serialNum,
                warrantyStartTime: this.ruleForm.warrantyStartTime,
                warrantyEndTime: this.ruleForm.warrantyEndTime,
                retireTime: this.ruleForm.retireTime,
                brand: this.ruleForm.brand,
                supplier: this.ruleForm.supplier,
                place: this.ruleForm.place,
                physicalAddress: this.ruleForm.physicalAddress,
                toService: this.ruleForm.toService.length ? this.ruleForm.toService.map(item => item.serialNumber) : [],
                toDocument: this.ruleForm.toDocument.length ? this.ruleForm.toDocument.map(item => item.serialNumber) : [],
                toUser: this.ruleForm.toUser.length ? this.ruleForm.toUser.map(item => item.userid) : [],
                description: this.ruleForm.description,
                toChange:this.ruleForm.toChange.map(item => item.serialNumber),
                toDeploy:this.ruleForm.toDeploy.map(item => item.serialNumber),
                toEvent:this.ruleForm.toEvent.map(item => item.serialNumber),
                toCmdb:this.ruleForm.toCmdb.map(item => item.serialNumber),
                toProblem:this.ruleForm.toProblem.map(item => item.serialNumber),
            }
        },

        // 点击确认时请求的参数
        request({ request, params }) {
//            const loading = this.$loading({
//                lock: true,
//                text: 'Loading',
//                spinner: 'el-icon-loading',
//                background: 'rgba(0, 0, 0, 0.7)'
//            });
            console.log(params)
            request(params)
                .then(res => this.$message.success('成功'))
                .catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message)
                })
                .finally(() => {
                    this.$modal.close()
                    this.callback()
                })
        },

        // 发送请求
        query() {
            sendServices.cmdbDescribe({ serialNumber: this.serialNumber })
                .then( res => {
                    this.ruleForm = { ...res }
                    this.configPros=res.configProperties
                    this.user = res.user.userid
                    this.owner = res.owner.userid
                    this.ruleForm.user = res.user.name
                    this.ruleForm.owner = res.owner.name
                    this.ruleForm.category = res.category.id
                    this.ruleForm.department = res.department.id
                    this.ruleForm.company = res.company.id +''
                    // this.ruleForm.company = this.company.fileter(item=>{
                    //     if(item.id){
                    //         if(item.id == res.company.id){
                    //             return item.name
                    //         }
                    //     }
                    // })
                    this.$refs.category.$el.children[0].children[0].value = res.category.title || ''
                    this.$refs.department.$el.children[0].children[0].value = res.department.title || ''
                    // console.log(this.ruleForm.category,'category');
                    // console.log(this.configPros,'configPros');
                    console.log(res.company)
                    console.log(this.company)
                })
                .catch( err => this.$message.error(err.message))
                .finally( () => this.loading = false)
        },

        // 获取接口数据
        getData() {
            switch (this.innerTitle) {
                case '影响服务':
                    this.ruleForm.toService = this.getChildData.map(item =>
                        ({
                            title: item.title,
                            serialNumber: item.serialNumber
                        })
                    )
                    break;
                case '厂商联系人':
                    this.ruleForm.toUser = this.getChildData.map(item =>
                        ({
                            userid: item.userid,
                            name: item.name
                        })
                    )
                    break;
                case '文件':
                    this.ruleForm.toDocument = this.getChildData.map(item =>
                        ({
                            serialNumber: item.serialNumber,
                            title: item.title
                        })
                    )
                    break;
            }
            this.innerVisible = false
        },

        // 内弹框
        innerPop(title) {
            this.innerVisible = true
            this.innerTitle = title
        },
        handleClick(tab, event){
            this.index = tab.index;
        }
    }
}
</script>

<style lang="scss" >
    #file_name{
        width: 400px;
        height: 30px;
    }
    a.input {
        width:70px;
        height:30px;
        line-height:30px;
        background:#3091d1;
        text-align:center;
        display:inline-block;/*具有行内元素的视觉，块级元素的属性 宽高*/
        overflow:hidden;/*去掉的话，输入框也可以点击*/
        position:relative;/*相对定位，为 #file 的绝对定位准备*/
        top:10px;
    }
    a.input:hover {
        background:#31b0d5;
        color: #ffffff;
    }
    a{
        text-decoration:none;
        color:#FFF;
    }
    #file {
        opacity:0;/*设置此控件透明度为零，即完全透明*/
        filter:alpha(opacity=0);/*设置此控件透明度为零，即完全透明针对IE*/
        font-size:100px;
        position:absolute;/*绝对定位，相对于 .input */
        top:0;
        right:0;
    }
    .el-tag {
        margin-left: 5px;
    }
    .having {
        position:relative;
    }
    .having ul {
        width: 200px;
        max-height: 200px;
        overflow-y: auto;
        position: absolute;
        top: 30px;
        background: #fff;
        z-index: 1000;
    }
    .having ul li:hover {
        background: #eee;
    }
    .configTab{
        /*background: yellow;*/
        .el-tabs__header{
                /*background: red;*/
                padding:0 43px;
            .el-tabs__nav-wrap{
                &::after{
                    width: 90%;
                }
            }
        }
        .el-tabs__content{
            .el-textarea__inner{
                width: 85%;
            }
        }
    }
</style>

